import axios from 'axios';
import { serviceOrigin, BoardsPathHeader } from '../config';


class HttpServices {
  constructor() {
    this.http = axios.create({
      baseURL: serviceOrigin,
      withCredentials: true,
      headers: {
        [BoardsPathHeader]: ''
      }
    });
  }

  static createQueryForPaging(itemsPerPage, page) {
    let queryParams = '';
    if (itemsPerPage) { 
      queryParams = `?itemsPerPage=${itemsPerPage}`;
    }
    if (page) {
      const symbol = !itemsPerPage ? '?' : '&';
      queryParams = `${queryParams}${symbol}page=${page}`;
    }
    return queryParams;
  }


  _setHeaderBoardsPath = (path = '') => ({ headers: { [BoardsPathHeader]: path } });

}

export default HttpServices;
